// Converting string's first letter to lower case if the string contains a _
export const firstToLowerCase = (s) => {
  let result = s.includes("_") ? s : s.charAt(0).toLowerCase() + s.slice(1);
  return result;
};

// Converting string from Snake Case to Camel Case
export const toCamel = (s) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace("-", "").replace("_", "");
  });
};

// Detects internal/test submissions that should not trigger analytics
// conversion events (dataLayer + Optimizely). The lead is still submitted.
export const isTestEmail = (email) => {
  if (!email || typeof email !== "string") {
    return false;
  }

  const normalized = email.trim().toLowerCase();

  // Suppress if the address contains any of these test/internal keywords
  const testKeywords = ["test", "example", "sample", "elevationb2b"];
  if (testKeywords.some((keyword) => normalized.includes(keyword))) {
    return true;
  }

  const domain = normalized.split("@")[1] || "";
  return domain.includes("pointclickcare");
};

// Remove special characters
export const noSpecialCharacters = (s) => {
  return s
    .replace(/[^\w -]/g, "")
    .replace(" - ", "-")
    .trim();
};
